import React, { Suspense, useEffect, useState } from 'react';
import contactService from '../Contacts/contactService';
import { CommonUtilities } from '../../commonUtils';
import Pagination from '../Header/Pagination';
import commonServices from './commonServices';
import Modal from 'react-responsive-modal';
import DeleteDialogueBox from './deleteDialogue';
import cachingMechanisum from './cachingMechanisum';

export default function SocietyList(param: any) {

    var [deleteJob, setDelete] = useState<any>([]);
    const [searchFor, setsearchFor] = useState("");
    const [saveAlert, setsaveAlert] = useState(false);
    const [deleteAlert, setdeleteAlert] = useState(false);
    var [editSocieties, initeditSocieties] = useState<any>([]);
    const [saveErrorAlert, setsaveErrorAlert] = useState(false);
    const [editSocietiesBtn, seteditSocietiesBtn] = useState("");
    const [allSocietiesList, initallSocietiesList] = useState<any>([]);
    const [totalRowsallSocieties, settotalRowsallSocieties] = useState(0);
    const [allSocietiesListTemp, initallSocietiesListTemp] = useState<any>([]);

    const Data: any = {
        pageNumber: 1,
        pageSize: 10,
        formArea: "allSocieties",
        usecode: "",
        useFreeText: "",
        //showSequence: 0
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        ApiCall();
    }

    const ApiCall = () => {

        if (searchFor.length > 0) {
            Data.usecode = searchFor;
            Data.useFreeText = searchFor;
        }

        commonServices.freeTextallSocieties(Data).then((value: any) => {
            initallSocietiesList(value);
            settotalRowsallSocieties(value.length);
            var obj = value.slice((Data.pageNumber - 1) * Data.pageSize, (Data.pageSize * Data.pageNumber));
            initallSocietiesListTemp(obj);
        })

    }

    useEffect(() => {
        if (param.open) {
            ApiCall();
            const PayeeStatus = "StatusPayee"

            var lookUpTypeListCache = cachingMechanisum.getCachingStorage("lookUpType");
            const PayeeStatusListing = lookUpTypeListCache?.filter((item: any) =>
                item.lookUpType.toLowerCase().includes(PayeeStatus.toLowerCase())
            );
        }

    }, [param.open]);

    const closeSocietyList = () => {

        param.closeSocietyList()
    }

    const freeTextCancelEdit = () => {
        seteditSocietiesBtn("");
        editSocieties = [];
        initeditSocieties(editSocieties)
    }

    const freeTextSave = () => {
        console.log(editSocieties)
        var valid = handleFieldRequired(editSocieties)

        if (valid) {
            commonServices.freeTextallSocietiesSave(editSocieties).then((value: any) => {
                setsaveAlert(true);
                ApiCall();
                seteditSocietiesBtn("");
            })

            setTimeout(function () {
                setsaveAlert(false);
            }, 3000);
        }

    }

    const handleFieldChange = (e: any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;

        console.log(Field_value)
        console.log(Field_type)
        if (Field_type === "checkbox") {
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');

        let updatedObject = { ...editSocieties };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        }

        console.log(updatedObject);
        initeditSocieties(updatedObject);
    };

    const handleFieldRequired = (object: any) => {
        var valid = true;
        Object.keys(object).map(key => {

            const isRequired = document.getElementById(key)?.hasAttribute('required');
            if (isRequired) {
                var fieldValidation = object[key];
                if (fieldValidation.length === 0) {
                    var fieldName: any = document.getElementById(key);
                    fieldName.style.border = "1px solid #ff0000";
                    valid = false;
                }
            }
        })

        return valid;
    };

    const allSocietySelect = (e: any) => {
        //initeditSocieties(e)
        param.allSocietySelect(e);
        param.closeSocietyList();
    }

    const Confirmation = (e: any) => {
        console.log(e)
        if (e === 1) {
            commonServices.freeTextallSocietiesDelete(deleteJob.freeId).then((value: any) => {
                setdeleteAlert(true);
            })

            setTimeout(function () {
                setdeleteAlert(false);
            }, 3000);
        }
        ApiCall();
        setDelete({});
    }

    return (
        <>
            <Modal open={param.open} onClose={() => closeSocietyList()}>

                <div className="span12">
                    <div className="box-header-main">
                        <h2 >Enter the Society name and ID</h2>
                    </div>
                    <div className="box-content">
                        {saveAlert && <div className="alert alert-success"> Society Code has been saved successfully </div>}

                        {saveErrorAlert && <div className="alert alert-danger">
                            There was a problem submitting your request, one or more fields are missing or incorrect.
                        </div>}

                        <div className="form-format ws-6">

                            <label className="control-label">Society </label>
                            <div className="label-entries">
                                <div className="ws-9">
                                    <input type="text" placeholder="Enter society" onChange={(e) => setsearchFor(e.target.value)} />
                                </div>

                                <div className="ws-3">
                                    <button className="icon-btn edit" onClick={ApiCall}> <i className="icon-search"></i> Search </button>
                                </div>

                            </div>
                        </div>

                        {totalRowsallSocieties === 0 && <div className="alert alert-info mt">No records to display </div>}

                        <div className="table-responsive">
                            {totalRowsallSocieties > 0 && <table className="newTable">
                                <thead>
                                    <tr>
                                        <th>Society Type</th>
                                        <th>Society Code</th>
                                        <th>Society Desc</th>
                                        <th>Sequence</th>
                                        <th>Operation </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allSocietiesListTemp?.map((values: any) => {

                                        return (
                                            <tr >
                                                <td >{values.formArea}</td>
                                                <td >{values.useCode}</td>
                                                <td >{values.useFreeText}</td>
                                                <td >{values.showSequence}</td>
                                                <td >
                                                    <button onClick={() => allSocietySelect(values)} className="icon-btn primary btn-sm mb pr"> <i className="icon-check"></i> Select </button>
                                                    <button onClick={() => { initeditSocieties(values); seteditSocietiesBtn("Edit"); }} className="icon-btn edit btn-sm" > <i className="icon-edit"></i> </button>
                                                    <button onClick={() => setDelete(values)} className="icon-btn delete btn-sm"> <i className="icon-close"></i> </button>
                                                </td>
                                            </tr>
                                        )
                                    })}

                                    {editSocietiesBtn && editSocietiesBtn.length > 0 && <tr>
                                        <td>
                                            <select value={editSocieties.formArea} id="formArea" onChange={(e) => handleFieldChange(e)} name="formArea" required>
                                                <option value="" >Choose a Society Type</option>
                                                <option value="Performance Society" label="Performance Society">Performance Society</option>
                                                <option value="Mechanical Society" label="Mechanical Society">Mechanical Society</option>
                                                <option value="Alternative Society" label="Alternative Society">Alternative Society</option>
                                            </select>
                                        </td>
                                        <td> <input type="text" id="useCode" name="useCode" onChange={(e) => handleFieldChange(e)}
                                            value={editSocieties.useCode} required disabled={editSocietiesBtn === 'Edit'} />         </td>
                                        <td> <input type="text" id="useFreeText" name="useFreeText"
                                            onChange={(e) => handleFieldChange(e)} value={editSocieties.useFreeText} required />    </td>
                                        <td> <input type="text" id="showSequence" name="showSequence"
                                            onChange={(e) => handleFieldChange(e)} value={editSocieties.showSequence} required />  </td>
                                        <td>
                                            <button className="icon-btn edit btn-sm" onClick={() => freeTextSave()}> <i className="icon-save"></i> Save </button>
                                            <button onClick={() => freeTextCancelEdit()} className="icon-btn delete btn-sm"> <i className="icon-close"></i> Cancel </button>
                                        </td>
                                    </tr>}


                                </tbody>
                            </table>}
                        </div>
                        <div className="clearfix ptl">
                            {
                                (() => {
                                    if (totalRowsallSocieties && totalRowsallSocieties > 10) {
                                        return <Pagination onChange={handleNameOnChange} totalRows={totalRowsallSocieties} />
                                    }

                                })()
                            }
                        </div>

                    </div>
                    <div className="box-footer">
                        <button className="icon-btn delete" onClick={() => closeSocietyList()}> <i className="icon-close"></i> Close </button>
                        <button className="icon-btn edit" onClick={() => seteditSocietiesBtn("Add")}> <i className="icon-save"></i> Add </button>
                    </div>

                    {
                        (() => {

                            if (deleteJob && deleteJob.useCode) {
                                return <DeleteDialogueBox param={true} message={"delete society code " + deleteJob.useCode} onChange={Confirmation} />
                            }
                        })()
                    }
                </div>
            </Modal>
        </>
    )

}